<div class="modal fade" bsModal #modal="bs-modal" [config]="{backdrop: 'static', keyboard: false}" tabindex="-1">
  <div class="modal-dialog modal-lg">
    <div class="panel padding-2 sm-panel">
      <div class="sm-head">
        <h1 class="sm-title"><i class="fa fa-columns"></i> Match the sheet's columns</h1>
        <div class="sm-sub">{{fileName}} · {{columns.length}} columns · {{rows?.length || 0}} rows</div>
      </div>
      <div class="sm-hint">
        Each template field on the left takes its value from the sheet column you pick. Columns with the same or a similar
        name are picked for you <span class="sm-auto">auto</span>; pick the rest yourself.
      </div>

      <div class="sm-notes" *ngIf="notes.length">
        <div class="sm-note" *ngFor="let note of notes"><i class="fa fa-info-circle"></i> {{note}}</div>
      </div>
      <div class="sm-legend"><span class="sm-star">*</span> required</div>

      <div class="sm-list">
        <div class="sm-row" *ngFor="let m of mappings" [class.sm-row-empty]="m.column < 0 && !m.ignored" [class.sm-row-ignored]="m.ignored"
             [class.sm-row-missing]="m.required && m.column < 0">
          <div class="sm-field">
            {{m.field}}<span class="sm-star" *ngIf="m.required">*</span>
            <div class="sm-tag" *ngIf="isOneOf(m)">branch or brick</div>
            <div class="sm-tag" *ngIf="m.ignored">ignored</div>
          </div>
          <div class="sm-arrow"><i class="fa fa-long-arrow-left"></i></div>
          <div class="sm-pick">
            <select class="form-control input-sm" [ngModel]="m.column" (ngModelChange)="pick(m, $event)" [disabled]="uploading || m.ignored">
              <option [ngValue]="-1">{{m.ignored ? '— Ignored for this upload —' : '— Not in the sheet (leave empty) —'}}</option>
              <option *ngFor="let c of columns; let i = index" [ngValue]="i">{{c || ('Column ' + (i + 1))}}{{usedElsewhere(m, i) ? '  (used for another field)' : ''}}</option>
            </select>
            <div class="sm-sample" *ngIf="m.column >= 0">
              <span class="sm-auto" *ngIf="m.auto">auto</span> {{sample(m) || 'no values in the first rows'}}
            </div>
          </div>
        </div>
      </div>

      <div class="sm-warn" *ngIf="unmatched">
        <i class="fa fa-exclamation-triangle"></i> {{unmatched}} field{{unmatched === 1 ? '' : 's'}} not matched — {{unmatched === 1 ? 'it' : 'they'}} will be uploaded empty.
      </div>
      <div class="sm-error" *ngFor="let p of problems"><i class="fa fa-times-circle"></i> {{p}}</div>
      <div class="sm-error" *ngIf="error">{{error}}</div>

      <div class="sm-progress" *ngIf="uploading">
        <crm-upload-progress [state]="job"></crm-upload-progress>
      </div>

      <div class="sm-foot">
        <button type="button" class="btn btn-cancel" (click)="cancel()">{{'app.cancel' | translate}}</button>
        <button type="button" class="btn btn-save" [disabled]="uploading || !mappings.length || problems.length > 0" (click)="upload()">Upload</button>
      </div>
    </div>
  </div>
</div>
